








































import Component from 'vue-class-component';
import { Mixins, Prop, Ref } from 'vue-property-decorator';
import { CreateAccountData } from '@/modules/backend/Dto/CreateAccountData';
import EditDialogWrapper from '@/layouts/EditDialogWrapper.vue';
import Mixin from '@/mixins/base';
import { AccountsModule } from '@/store/dashboard/accounts/AccountsModule';
import { resolveModule } from '@/store';
import { ValidationObserver } from '@/plugins/vee-validate';

@Component({
  mixins: [Mixin],
  components: {
    'edit-dialog-wrapper': EditDialogWrapper
  }
})
export default class AccountCreateDialog extends Mixins(Mixin) {
  private readonly accountsModule: AccountsModule = resolveModule(AccountsModule);

  @Ref('observer')
  private readonly observer!: ValidationObserver;

  @Prop({ required: true, type: Number })
  private readonly locationId!: number;

  private readonly form: CreateAccountData = {
    locationId: this.locationId,
    content: '',
    name: ''
  };

  private clearForm(): void {
    this.observer.reset();
    this.form.name = '';
    this.form.content = '';
  }

  private dialogOpenHandler(): void {
    this.form.locationId = this.locationId;
    this.clearForm();
  }

  private async create(): Promise<void> {
    this.observer.reset();

    if (await this.observer.validate()) {
      await this.accountsModule.Create(this.form);
    } else {
      throw new Error('Validation error');
    }
  }
}
